<template>
  <!--PC端-->
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">个人中心</span>
      <!--<span style="margin-right:10px;" slot="orderList">我的订单</span>-->
    </nav-bread>
    <div class="container">
      <el-container>
        <div class="biaot"><p class="mshow">物流详情&nbsp;&nbsp;>&nbsp;&nbsp; 标本管理</p>
          <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        </div>
        <el-container style="margin:20px 0 0 20px;">
          <el-header class="mhide">物流详情 &nbsp;&nbsp;>&nbsp;&nbsp; 物流单号: {{courierNum}}</el-header>
          <el-main v-loading="loading">
            <div class="courier_follow">
              <div class="follow_status" >
                <div class="follow_address" v-for="(item,index) in courierList" :key="index">
                  <div v-if='index == 0'>
                    <div class="label default"></div>
                    <div class="address default">{{item.context}}</div>
                    <div class="date">{{item.ftime}}</div>
                  </div>
                  <div v-else>
                    <div class="label"></div>
                    <div class="address">{{item.context}}</div>
                    <div class="date">{{item.ftime}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="errormsg" v-if="message">
              {{message}}
            </div>
          </el-main>


        </el-container>
      </el-container>


    </div>
  </div>

</template>

<script>
  import NavLeft from '@/components/NavLeft.vue'
  import NavHeader from '@/components/Header.vue'
  import NavBread from '@/components/Bread.vue'
  import {getCookie, setCookie} from "../../util/util";
  import axios from 'axios'

  export default {
    name: "order-logistics",
    data() {
      return {
        courierNum: this.$route.query.courierNum,
        courierCo: this.$route.query.courierCo,
        p_activeIndex: "1",
        courierList: [],
        reversedNum: [],
        active: 1,
        message: "",
        p_showSearch:true,
        p_loginModalFlag:false,
        loading:true
      }
    },
    components: {
      NavLeft,
      NavHeader,
      NavBread
    },
    methods: {
      p_showLoginModal(){
        this.p_loginModalFlag = true
      },

      p_closeLoginModal(){
        this.p_loginModalFlag = false
      },

      getCourierList() {
        console.info(this.courierNum)
        axios.get("/jys/courier", {
          params: {
            courierNum: this.courierNum,
            courierCo: this.courierCo
          },
        }).then((response) => {
          this.loading = false
          this.courierList = response.data.data
          if (response.data.returnCode == 500) {
            this.message = response.data.message
            console.info(this.message)
          }
        })
      }
    },
    mounted() {
      if(getCookie("_token")){
        this.getCourierList()
      }else{
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.$refs.navHeader.logout()
      }
    }
  }
</script>

<style scoped>
  .courier_follow {
    margin-left: 50px
  }

  .courier_follow .follow_status {
    border-left: 1px solid #d5d5d5 !important;
  }

  .courier_follow .follow_status .follow_address {
    /*border-bottom: 1px solid #d5d5d5;*/
    margin: 0 20px;
    margin-top: 25px;
    padding-bottom: 25px;
    position: relative;
  }

  .courier_follow .follow_status .follow_address .address {
    line-height: 60px;
  }

  .courier_follow .follow_status .follow_address .label {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    position: absolute;
    left: -30px;
    top: -5px;
    background: #d5d5d5;
  }

  .courier_follow .follow_status .follow_address .label.default {
    background: #00C5B0;
  }

  .courier_follow .follow_status .follow_address .default {
    color: #00C5B0;
  }

  .errormsg {
    width: 100%;
    height: 200px;
    line-height: 200px;
    text-align: center
  }
  .mshow{
    display: none;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .mshow {
      display: block;
    }
    .mhide{
      display: none;
    }
    .biaot {
      background-color: #F0F0F0;
      color: #333;
      font-size: 11px;
      text-align: left;
      position: relative;
      line-height: 32px;
      margin: 0;
      padding: 0 10px;
      border-left: 5px solid #00C5B0;
    }
    .biaot div {
      position: absolute;
      right: 0;
      height: 32px;
      top: 0;
    }
    /deep/ .navbar-right-container,/deep/ .navbar-left-container img,/deep/ .hideel{
      display: none!important;
    }
    /deep/ .out {
      color: rgba(0, 196, 170, 1);
      padding-left: 0;
      margin-right: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/user/OrderLogistics.vue